import { render, staticRenderFns } from "./Kchannel.vue?vue&type=template&id=644204e0"
import script from "./Kchannel.vue?vue&type=script&lang=js"
export * from "./Kchannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports